import { Fragment } from 'react'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import DataTableComponent from './Customers'

const Customers = () => {
    return (
        <Fragment>
            <Container fluid={true} style={{ paddingTop: '30px' }}>
                <Row>
                    <Col sm='12'>
                        <Card>
                            <CardBody style={{ padding: '15px' }}>
                                <DataTableComponent />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
};

export default Customers;